import { create } from "zustand";
import { initSocket, disconnectSocket } from "../services/socket";
import useDashboardStore from "./dashboardStore";
import chatStore from "./chatStore";
import api from "../services/api";
import { ENDPOINTS } from "../utils/endpoints";

const useAuthStore = create((set, get) => ({
  user: JSON.parse(localStorage.getItem("user")) || null,
  userMeta: JSON.parse(localStorage.getItem("userMeta")) || null,
  isAuthenticated: localStorage.getItem("user"),
  socket: null,

  setSocket: (socketInstance) => set({ socket: socketInstance }),

  setUserMeta: (userMeta) => {
    localStorage.setItem("userMeta", JSON.stringify(userMeta));
    set({ userMeta });
  },

  login: (accessToken, user, userMeta) => {
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("userMeta", JSON.stringify(userMeta));
    const socket = initSocket(userMeta.session_id);
    set({ user, userMeta, isAuthenticated: true, socket });
  },

  logout: () => {
    localStorage.removeItem("user");
    localStorage.removeItem("userMeta");
    localStorage.removeItem("lastScreen");
    localStorage.removeItem("accessToken");
    disconnectSocket();
    useDashboardStore.getState().resetDashboard();
    chatStore.getState().resetChat();
    set({ user: null, userMeta: null, isAuthenticated: false, socket: null });
  },

  // ✅ Refresh IAP status from server (for cross-platform sync)
  refreshIapStatus: async () => {
    try {
      const { data } = await api.get(ENDPOINTS.IAP_CHECK_ACCESS);
      if (data.hasAccess) {
        const currentUserMeta = get().userMeta;
        const updatedUserMeta = {
          ...currentUserMeta,
          has_active_iap: true,
        };
        localStorage.setItem("userMeta", JSON.stringify(updatedUserMeta));
        set({ userMeta: updatedUserMeta });
      }
    } catch (e) {
      // Silently fail — don't block access
      console.log("IAP check failed:", e);
    }
  },

  updateMembershipDetails: (
    oldUserMeta,
    is_membership_active,
    membership_ids,
  ) => {
    const newUserMeta = {
      ...oldUserMeta,
      is_membership_active,
      membership_ids,
    };
    localStorage.setItem("userMeta", JSON.stringify(newUserMeta));
    set({ userMeta: newUserMeta });
  },
}));

export default useAuthStore;
